export let VIDEO_CARDS_ORIENTATIONS = /*#__PURE__*/function (VIDEO_CARDS_ORIENTATIONS) {
  VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["VERTICAL"] = 1] = "VERTICAL";
  VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["HORIZONTAL"] = 2] = "HORIZONTAL";
  return VIDEO_CARDS_ORIENTATIONS;
}({});
//# sourceMappingURL=orientations.js.map